import request from "@/utils/request";

export function formGet(params) {
    return request({
        url: "/api/services/app/Form/Get",
        method: "get",
        params
    });
}

export function formGetPublic(params) {
    return request({
        url: "/api/services/app/Form/GetPublic",
        method: "get",
        params
    });
}

export function formGetAllGrouped(params) {
    return request({
        url: "/api/services/app/Form/GetAllGrouped",
        method: "get",
        params
    });
}

export function formGetAll(params) {
    return request({
        url: "/api/services/app/Form/GetAll",
        method: "get",
        params
    });
}

export function formGetCount(params) {
    return request({
        url: "/api/services/app/Form/GetCount",
        method: "get",
        params
    });
}

export function formGetSubjectFields(params) {
    return request({
        url: "/api/services/app/Form/GetSubjectFields",
        method: "get",
        params
    });
}

export function formGetAllForDropdown(params) {
    return request({
        url: "/api/services/app/Form/GetAllForDropdown",
        method: "get",
        params
    });
}

export function formGetAllBreedingSubjectTypeForDropdown(params) {
    return request({
        url: "/api/services/app/Form/GetBreedingSubjectTypeDropdown",
        method: "get",
        params
    });
}

export function formGetCustomFields(params) {
    return request({
        url: "/api/services/app/Form/GetFormCustomFields",
        method: "get",
        params
    });
}

export function formGetAllWithMediaLength(params) {
    return request({
        url: "/api/services/app/Form/GetAllWithMediaLength",
        method: "get",
        params
    });
}

export function formCreate(data) {
    return request({
        url: "/api/services/app/Form/Create",
        method: "post",
        data
    });
}

export function formCreateBreedingForm(data) {
    return request({
        url: "/api/services/app/Form/CreateBreedingForm",
        method: "post",
        data
    });
}

export function formUploadImage(data) {
    return request({
        url: "/api/services/app/Form/UploadImage",
        method: "post",
        data
    });
}

export function breedingFormUpdate(data) {
    return request({
        url: "/api/services/app/Form/UpdateBreedingForm",
        method: "put",
        data
    });
}

export function formUpdate(data) {
    return request({
        url: "/api/services/app/Form/Update",
        method: "put",
        data
    });
}

export function formUpdatePublic(data) {
    return request({
        url: "/api/services/app/Form/UpdatePublic",
        method: "put",
        data
    });
}

export function formUpdateCustomFields(data) {
    return request({
        url: "/api/services/app/Form/UpdateFormCustomFields",
        method: "put",
        data
    });
}

export function formUpdateSequence(data) {
    return request({
        url: "/api/services/app/Form/UpdateSequence",
        method: "put",
        data
    });
}

export function formDelete(params) {
    return request({
        url: "/api/services/app/Form/Delete",
        method: "delete",
        params
    });
}


// WEBPACK FOOTER //
// ./src/api/form.js